import { TemplatePage } from './types';

const live_streaming_thumbnails: TemplatePage = {
  header: {
    color: '#B5B2F5',
    icon: 'images/video-templates/stream_thumbnails.jpg',
    title: 'Thumbnail Templates for Live Streams',
    title_meta: '20+ Free Thumbnail Templates for Live Streams',
    description_meta:
      ' Design stylish thumbnails for your live streams with the help of Wave.video’s free & easily ' +
      'customizable templates. Inspire people to tune in for your show!',
    description:
      'Make catchy image previews for your live streams with our easily customizable templates. Pick a style ' +
      'that matches your brand and create a scroll-stopping thumbnail in minutes.'
  },
  footer: {
    category: 'Thumbnail for Live Streams',
    description:
      'With Wave.video’s collection of editable templates, you can create professional thumbnails for your ' +
      'live streams on YouTube, Facebook, Instagram, Linkedin, and other social media platforms. With no design ' +
      'skills, you can make a stylish thumbnail and easily resize it for any platform. Mix text, stock assets, ' +
      'and fun overlays with your photos and get as many viewers as possible.'
  },
  content: [
    {
      type: 'templates',
      title: 'Thumbnail Templates for Live Streams',
      search: { name: 'LiveThumbnail', tags: 'LiveThumbnail' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_thumbnails;
